import React from 'react'
import { Card, Col } from 'react-bootstrap'

const BrandCard = ({ img, cardText }) => {
  return (
    <Col
      xs="12"
      sm="6"
      lg="3"
      className="my-2 d-flex justify-content-center">
      <Card className="my-1">
        <Card.Img className='d-block mx-auto categoty-card-img px-3' src={img} />
      </Card>
    </Col>
  )
}

export default BrandCard
